import { EditorState as r } from "@codemirror/state";
const o = () => r.readOnly.of(!0);
export {
  o as readonly
};
//# sourceMappingURL=readonly-tcxWvTqP.js.map
